import React from "react";
import Card from "react-bootstrap/Card";
import Topbar from "../../components/Topbar";
import Button from "react-bootstrap/Button";
import Nav from "react-bootstrap/Nav";
import Image from "react-bootstrap/Image";
import Bucket from "../../images/Bucket.jpg";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PromptSuggestions from "../../components/Generator/PromptSuggestions";
import TxtToImg from "../../components/Generator/TxtToImg";
import StyleSelector from "../../components/Generator/StyleSelector";

// Second lesson, introduces how prompts can steer the direction of text-to-image
// generation.

class SecondLesson extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Prompt Suggestions and Styles",
      length: "15 Minutes",
      description:
        "This lesson will go over the usage of prompt suggestions and styles.",
      topics: ["Prompt Suggestions", "Styles"],
      page: "../lessons/second",
    };
  }

  render() {
    return (
      <div className="lesson" style={{ backgroundColor: "#727c8f" }}>
        <Topbar />
        <div style={{ height: "1vh" }}></div>
        <div className="d-flex justify-content-center">
          <Card>
            <Card.Header className="bg-success text-white text-center">
              <h3>{this.state.title}</h3>
            </Card.Header>
            <Card.Body style={{ maxWidth: "75vw" }}>
              <div className="text-center">
                <Card.Title>Lesson Length: {this.state.length}</Card.Title>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div className="text-center">
                <Image src={Bucket} width="25%" height="25%" />
              </div>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Hello, and welcome to our lesson on prompt suggestions and
                  styles. Prompt suggestions are helpful optional words to tag
                  on to a prompt while styles can generate images in a specific
                  style such as animated or illustrated.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Prompt suggestions can help with prompt creation by providing
                  optional words to fine tune prompt creation. Below you will
                  see our list of prompt suggestions:
                </Card.Text>
              </div>
              <div className="text-center">
                <Container fluid>
                  <Row>
                    <Col md={{ span: 4, offset: 0 }}>
                      <br />

                      <br />
                    </Col>
                    <Col md={{ span: 4, offset: 0 }}>
                      <br />
                      <PromptSuggestions />
                      <br />
                    </Col>
                    <Col md={{ span: 4, offset: 0 }}>
                      <br />

                      <br />
                    </Col>
                  </Row>
                </Container>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  By clicking on one of those promp suggestions you can see it
                  being added to the textbox below. Test it out by creating a
                  "Smooth Bucket Jumping":
                </Card.Text>
              </div>
              <Container fluid>
                <Row>
                  <Col md={{ span: 2, offset: 0 }}>
                    <br />

                    <br />
                  </Col>
                  <Col md={{ span: 8, offset: 0 }}>
                    <br />
                    <TxtToImg />
                    <br />
                  </Col>
                  <Col md={{ span: 2, offset: 0 }}>
                    <br />

                    <br />
                  </Col>
                </Row>
              </Container>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  As you can see, using prompt suggestions can create an image
                  quickly but not every word in existence can be found so be
                  sure to mix and match with your own words.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Styles can also be used to fine tune image creation. If you
                  want an image in a specific style such as "animated" you can
                  do so by clicking on the "animated" style below and generating
                  your image using the same generator above:
                </Card.Text>
              </div>
              <div className="text-center">
                <Container fluid>
                  <Row>
                    <Col md={{ span: 4, offset: 0 }}>
                      <br />

                      <br />
                    </Col>
                    <Col md={{ span: 4, offset: 0 }}>
                      <br />
                      <StyleSelector />
                      <br />
                    </Col>
                    <Col md={{ span: 4, offset: 0 }}>
                      <br />

                      <br />
                    </Col>
                  </Row>
                </Container>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Prompt suggestions and styles are very useful in providing
                  direction to fine tune an image, enhancing creativity by
                  providing similar prompts that allow the generator to create
                  more unique images, and improving the quality of an image by
                  giving the generator more guidance towards an accurate image
                  that the user wants.
                </Card.Text>
              </div>
              <div
                style={{
                  fontSize: "4.0rem",
                  fontWeight: "bold",
                  padding: "1vh",
                }}
              >
                <div className="text-center">Congratulations!</div>
              </div>
              <div
                style={{
                  fontSize: "2.0rem",
                  fontWeight: "bold",
                  padding: "1vh",
                }}
              >
                <div className="text-center">
                  You have completed your second lesson in Diffractive!
                </div>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div className="d-flex justify-content-center">
                <Nav>
                  <Nav.Link id="SecondReturn" href="../lessons" variant="dark">
                    <Button variant="info">Return to Lessons</Button>
                  </Nav.Link>
                </Nav>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
}

export default SecondLesson;
